import { formatIconImg, formatImgSag, formatTags } from './formatters';
import { formatSagAttr } from './formatters/attributes';
import { isSAGMax } from './formatters/helpers';
import { RPGLink, RPGTypes } from './formatters/types';
import type { Options, PokerGameTile, SagType } from './types';

const numPlayers = (flags: number) => (isSAGMax(flags) ? '3-8' : '3');

const mapSagType = (
  {
    staticData: {
      scriptId,
      clubId,
      buyin: buyIn,
      currency,
      game,
      maxPrizePool,
      rake,
      server,
      serverObj,
      structure,
      flags,
      isPlayMoney,
      speedDisplay,
      scalePM,
      tournGroup,
      isHiLo
    },
    lastEntry,
    ngSagFlags,
    lobbyNewsContentData
  }: SagType,
  { language }: Options
) => ({
  id: scriptId + lastEntry,
  clubId,
  type: RPGTypes.SAG,
  link: RPGLink.SAG,
  imageUrl: formatImgSag(game, flags, ngSagFlags, tournGroup),
  imageUrlV2: formatImgSag(game, flags, ngSagFlags, tournGroup, true),
  tags: formatTags({
    game,
    structure,
    speedDisplay,
    maxPerTable: isSAGMax(flags) ? undefined : 3,
    isHiLo: Boolean(isHiLo)
  }),
  attributes: formatSagAttr(
    {
      buyIn,
      rake,
      currency,
      maxPrizePool,
      isPlayMoney: Number(isPlayMoney),
      players: numPlayers(flags),
      scalePM,
      lobbyNewsContentData
    },
    language
  ),
  // AQA-31671 - SAG is oddly tagged the same as SNG for these icons
  iconUrl: formatIconImg(RPGTypes.SNG),
  lastEntry,
  server,
  serverObj
});

const mapSagTypesFn = (sagTypes: SagType[], options: Options): PokerGameTile[] =>
  sagTypes.map((type) => mapSagType(type, options));

export default mapSagTypesFn;
